module.exports = __webpack_public_path__ + "static/media/sexpirikos-writer-image.02a00cb4.JPG";